export enum RulesetConditionOperatorEnum {
  EQ = "eq",
  ANY = "any",
  NOT = "not",
  NONE = "none",
}
